import NameAvatar from './NameAvatar'

export default NameAvatar
